import { NavigationLinkCategory } from '../models/navigation-link';

export const navigation: NavigationLinkCategory[] = [
    new NavigationLinkCategory(1, 'Handyversicherung', '/produkte/handyversicherung', []),
    new NavigationLinkCategory(2, 'Tabletversicherung für die Schule', '/produkte/tablet-versicherung-plus', []),
    new NavigationLinkCategory(3, 'Elektronikversicherung', '/produkte/elektronikversicherung', []),
];
